import { loader } from 'graphql.macro'

export default async function updateFeeType ({ dataLoaders, variables }) {
  const schema = loader('./updateFeeType.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateFeeType
}
